import './DataSetLoadingIcon.css';

/**
 * The loader shown next to a data set's name while its scrape runs: the same Violerts
 * signal-arcs spinner as the Tasks page (public/violerts-spinner.svg), sized for a sidebar row.
 * A bare inline <img> rather than <Spinner>, whose block container is not valid inside a button.
 *
 * @param {string} className Extra classes on the icon, e.g. spacing utilities
 */
function DataSetLoadingIcon({ className }) {
	return (
		<img
			className={`dataset-loading-spinner vio-spinner ${className ? className : ''}`}
			src="/violerts-spinner.svg"
			alt=""
			aria-hidden="true"
		/>
	);
}

export default DataSetLoadingIcon;
